import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UtilsService} from '../../../core/utils/utils.service';
import {ProduitArticleDTO} from '../../../core/dtos/produit-article-dto';
import {ActivatedRoute} from '@angular/router';
import {StocksService} from '../../../core/services/gestion-stock/stocks.service';
import {Subscription} from 'rxjs';
import {ModelViewInventaire} from '../inventaire/model-view-inventaire';
import {InventaireFilters} from '../../../core/models/gestion-stock/inventaire-filters.model';
import {ProduitDeclinaisonService} from '../../../core/services/entities/produit-declinaison.service';
import {MSG_KEY, MSG_SEVERITY} from '../../../core/constants';
import {ToastService} from "../../../core/services/technique/toast.service";
import {DATAGRID_ROW_TYPES} from "../../../core/services/technique/devextreme.service";
import {DxDataGridComponent} from "devextreme-angular";
import {ButtonThemeEnum} from "../../../shared/ui/button/button-theme-enum";

@Component({
    selector: 'yo-matieres-premieres',
    templateUrl: './matieres-premieres.component.html',
    styleUrls: ['./matieres-premieres.component.scss'],
    standalone: false
})
export class MatieresPremieresComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  subRoute: Subscription;
  subResultSearchStocks: Subscription;
  subLoadStocks: Subscription;
  subRefreshStocks: Subscription;
  subSearchStock: Subscription;

  articles: ProduitArticleDTO[] = [];
  matieresPremieres: ModelViewInventaire[] = [];
  selectedMatierePremiere: ModelViewInventaire;
  previousSelectedMatierePremiereTag: HTMLElement;
  totalDenrees = 0;
  stocks: ModelViewInventaire[] = [];

  // criteres de la recherche du panneau gauche
  filters: InventaireFilters;

  feature: string;

  stocksAnnounced: boolean = false;

  page: number = 1;
  pageSize: number = 50;

  isDataRetrieved: boolean = false;

  @ViewChild('grid') grid: DxDataGridComponent;
  displayDialogAjoutLot: boolean;
  displayDialogPerimes: boolean;

  constructor(public utils: UtilsService,
              private stocksSvc: StocksService,
              private produitDeclinaisonSvc: ProduitDeclinaisonService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.initOnRequest();
    // notifier le composant de recherche qu'on ait sur la fonctionnalité
    this.subscritionRouteData();
    // s'abonner à la recherche des articles dans le stock
    this.subscritionResultSearchStocks();
    // declencher la recuperation des lignes de stock d'une matiere premiere
    this.subscriptionLoadStocks();
    this.subscriptionRefreshMatieresPremieresAndStocks();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subResultSearchStocks);
    this.utils.unsubscribe(this.subRoute);
    this.utils.unsubscribe(this.subLoadStocks);
    this.utils.unsubscribe(this.subRefreshStocks);
    this.utils.unsubscribe(this.subSearchStock);
  }

  initOnRequest = () => {
    this.subSearchStock = this.produitDeclinaisonSvc.onSearchStocks$.subscribe(() => {
      this.isDataRetrieved = false;
      this.updateLoadingPopup();
    })
  }

  subscritionResultSearchStocks = () => {
    this.updateLoadingPopup();
    this.subResultSearchStocks = this.produitDeclinaisonSvc.resultSearchStocksForMatieresPremieres$
      .subscribe(response => {
        this.stocks = [];
        this.matieresPremieres = response.resultList;
        this.totalDenrees = response.additionalProperties['totalDenrees'];
        this.filters = response.additionalProperties['filters'];
        this.page = this.filters.page ? this.filters.page : 1;
        this.pageSize = this.filters.size ? this.filters.size : 50;
        this.stocksAnnounced = false;

        // recharger les lignes de lot si une matiere premiere est selectionnée et toujours visible
        this.selectedMatierePremiere = this.utils.preSelectSingleList(this.matieresPremieres, this.selectedMatierePremiere);

        if (!this.utils.isNullOrEmpty(this.selectedMatierePremiere)) {
          this.stocksAnnounced = true;
          this.stocksSvc.announceLoadStocks(this.selectedMatierePremiere);
        }

        this.isDataRetrieved = true;
        this.updateLoadingPopup();
      });
  };

  subscritionRouteData = () => {
    this.subRoute = this.route.url.subscribe(response => {
      this.feature = response[0].path;
      this.stocksSvc.announceFeature(this.feature, this.page, this.pageSize);
    });
  };

  subscriptionLoadStocks = () => {
    this.stocksSvc.loadStocks$.subscribe(selectedMatierePremiere => {
      this.stocks = selectedMatierePremiere.children;
      this.selectedMatierePremiere = selectedMatierePremiere;
    });
  };

  subscriptionRefreshMatieresPremieresAndStocks = () => {
    this.subRefreshStocks = this.stocksSvc.loadMatieresPremieresAndStocks$
      .subscribe(() => {
        this.stocksSvc.announceFeature(this.feature, this.page, this.pageSize);
      });
  }

  onRowSelect = ($event: any) => {
    if ($event.rowType === DATAGRID_ROW_TYPES.DATA) {
      this.stocks = [];
      if ($event.data && !$event.data.noStock) {
        this.stocksAnnounced = true;
        $event.rowElement.classList.add('selected-row');
        if (this.previousSelectedMatierePremiereTag && this.previousSelectedMatierePremiereTag !== $event.rowElement) {
          this.previousSelectedMatierePremiereTag.classList.remove('selected-row');
        }
        this.previousSelectedMatierePremiereTag = $event.rowElement;
        this.stocksSvc.announceLoadStocks($event.data);
      }
    }
  };

  openDialogPerimes = () => {
    this.displayDialogPerimes = true;
    this.stocksSvc.announceOpenDialogPerimes();
  };

  openDialogAjoutLot = (selectedMatierePremiere: ModelViewInventaire, $event: any) => {
    $event.stopPropagation();
    this.displayDialogAjoutLot = true;
    this.selectedMatierePremiere = selectedMatierePremiere;
    this.produitDeclinaisonSvc.announceOpenDialogAjoutLot(this.selectedMatierePremiere, null);
  };

  onRowPrepared = ($event: any) => {
    if ($event.rowType === DATAGRID_ROW_TYPES.DATA) {
      if ($event.data?.noStock) {
        $event.rowElement.classList.add('no-stock');
      } else {
        $event.rowElement.classList.add('stock');
      }
    }
  };

  handlePageChange = (page: number) => {
    if (page === this.page) return;
    this.stocksAnnounced = false;
    this.stocks = [];
    this.page = page;
    this.produitDeclinaisonSvc.announcePaginationSearchStock({page: this.page - 1, size: this.pageSize});
  };

  handlePageSizeChange = (size: number) => {
    if (size === this.pageSize) return;
    this.stocksAnnounced = false;
    this.stocks = [];
    this.pageSize = size;
    this.page = 1;
    this.produitDeclinaisonSvc.announcePaginationSearchStock({page: 0, size});
  };

  private updateLoadingPopup = () => {
    if (this.grid) {
      if (!this.isDataRetrieved)
        this.grid.instance.beginCustomLoading("Chargement en cours");
      else
        this.grid.instance.endCustomLoading();
    }
  }

  onInitialized = () => {
    this.updateLoadingPopup();
  };
}
